
	export default {
		props: {
			allTags: Object,
		},
		methods: {
			filterContent() {
				this.$emit("filter-content", this.$parent.selectedTags);
			},
            closeModal() {
                this.$emit('close');
            },
			clearFilters() {
				this.$parent.selectedTags = [];
				this.filterContent();
			}
		}
	}
